__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(54158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(127), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "9.1.1", () => (Promise.all([__webpack_require__.e(485), __webpack_require__.e(923), __webpack_require__.e(967), __webpack_require__.e(217), __webpack_require__.e(127), __webpack_require__.e(539)]).then(() => (() => (__webpack_require__(80217))))));
			register("@platform/api-client", "0.1.0", () => (Promise.all([__webpack_require__.e(509), __webpack_require__.e(335), __webpack_require__.e(29)]).then(() => (() => (__webpack_require__(54029))))));
			register("@platform/shared-types", "0.1.0", () => (__webpack_require__.e(974).then(() => (() => (__webpack_require__(974))))));
			register("@platform/store", "0.1.0", () => (Promise.all([__webpack_require__.e(509), __webpack_require__.e(301)]).then(() => (() => (__webpack_require__(68301))))));
			register("@platform/ui-components", "0.1.0", () => (Promise.all([__webpack_require__.e(485), __webpack_require__.e(967), __webpack_require__.e(982), __webpack_require__.e(127), __webpack_require__.e(335), __webpack_require__.e(539), __webpack_require__.e(520), __webpack_require__.e(795), __webpack_require__.e(883)]).then(() => (() => (__webpack_require__(59512))))));
			register("react-dom", "19.2.7", () => (() => (__webpack_require__(40961))), 1);
			register("react-router-dom", "7.18.4", () => (() => (__webpack_require__(55214))), 1);
			register("react", "19.2.7", () => (() => (__webpack_require__(96540))), 1);
			register("zustand", "5.0.14", () => (__webpack_require__.e(618).then(() => (() => (__webpack_require__(55618))))));
			initExternal(33666);
			initExternal(53846);
			initExternal(74050);
			initExternal(43182);
			initExternal(29082);
			initExternal(17200);
			initExternal(29058);
			initExternal(30946);
			initExternal(41722);
			initExternal(36510);
			initExternal(75666);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};